
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[cate]",
      function () {
        return require("private-next-pages/magazine/[cate]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/[cate]"])
      });
    }
  